import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=e1160862&scoped=true&"
import script from "./page1.vue?vue&type=script&lang=js&"
export * from "./page1.vue?vue&type=script&lang=js&"
import style0 from "./page1.vue?vue&type=style&index=0&id=e1160862&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1160862",
  null
  
)

export default component.exports